// extracted by mini-css-extract-plugin
export default {"item":"slider_item__Ir+y3","img":"slider_img__WVtWV"};